import styled from "styled-components";
import PlayArea from "./PlayArea/PlayArea";
import {
  GridCoordinates,
  gridCoordinatesGet,
  playAreaIdGet,
} from "./PlayAreas.logic";
import { AreaSource } from "type/panel/Panel.type";
import { useEffect, useState } from "react";

type Props = {
  playAreas: AreaSource[];
};

const PlayAreas = ({ playAreas }: Props) => {
  const [playActive, setPlayActive] = useState<boolean>(true);
  useEffect(() => {
    setInterval(() => {
      setPlayActive(false);
    }, 50 * 1000);
  }, []);
  useEffect(() => {
    if (!playActive) {
      setPlayActive(true);
    }
  }, [playActive]);

  const playMapInd: number = 0;
  let areas: any[] = [];
  for (let i = playAreas.length - 1; i >= 0; i--) {
    const areaSource = playAreas[i];
    const gridCoordinates: GridCoordinates = gridCoordinatesGet(
      areaSource.area
    );
    const areaId: string = playAreaIdGet(playMapInd, i);
    areas.push(
      <PlayAreaDiv key={areaId} id={areaId} $gridCoordinates={gridCoordinates}>
        <PlayArea areaSource={areaSource} playMapInd={playMapInd} areaInd={i} />
      </PlayAreaDiv>
    );
  }

  return <>{playActive && areas}</>;
};

const PlayAreaDiv = styled.div<{ $gridCoordinates: GridCoordinates }>`
  grid-column-start: ${(props) => props.$gridCoordinates.columnStart ?? 0};
  grid-column-end: ${(props) => props.$gridCoordinates.columnEnd ?? 0};
  grid-row-start: ${(props) => props.$gridCoordinates.rowStart ?? 0};
  grid-row-end: ${(props) => props.$gridCoordinates.rowEnd ?? 0};
`;

export default PlayAreas;
